<template>
    <Section
        v-if="$validateText(data.primary.html)"
        width="sm"
    >
        <div class="custom-html rich-text" v-html="html" />
    </Section>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    computed: {
        html() {
            const field = this.data.primary.html;
            const html = Array.isArray(field)
                ? field.map(block => block.text).join('\n')
                : field;

            return html
                .replaceAll('<table', '<div class="table-container mobile-scroll-shadow"><table class="table-container__table"')
                .replaceAll('</table>', '</table></div>');
        }
    }
};
</script>

<style lang="scss" scoped>
    .custom-html::v-deep {
        .table-container {
            margin: 1.5rem 0;
        }
        ul,
        ol {
            margin: 20px 0;
        }
        td,
        th {
            min-width: 110px;
        }
    }
</style>
